const LIQUID_ENGINE = 'liquid_engine';

/**
 * Whether or not a gig is considered a "rising talent".
 * @param  {String} [gigType=''] The gig's type.
 * @return {Boolean}
 */
export const isRisingTalent = (gigType = '') => gigType === LIQUID_ENGINE;



// WEBPACK FOOTER //
// ./src/utils/isRisingTalent/index.js